module.exports = __webpack_public_path__ + "static/media/SomersetBridgeInsuranceServicesLimitedLogoForUnderwriterSelection.9d694a66.png";